import React from 'react';

import { Box } from 'ui/Layout';
import { Text } from 'ui/Typography';

import logoText from '../../assets/logo-text.svg';
import { fadeInAnimation } from '../../constants';

const BrandingLead: React.FC = () => {
  return (
    <Box mx="20px" mb="5vh">
      <Box
        m="auto"
        maxW="320px"
        w="80vw"
        _open={{
          animation: `${fadeInAnimation} 300ms ease-out`,
        }}
      >
        <img src={logoText} />
      </Box>
      <Text fontSize="xl" fontWeight="300" textAlign="center">
        Turn financial statements into beautiful Sankey diagrams
      </Text>
    </Box>
  );
};

export default BrandingLead;
